// extracted by mini-css-extract-plugin
module.exports = {"root":"TVMkiEobCWB4hGicCK2m","center":"GoyNts3qRjV4hYwqJUKz","left":"yn4O6DOFCnsahAMPWlLa","image":"YEe33cQoldg8zu4zc0O7"};